import React from "react";
import {styled} from "@mui/material/styles";
import Rating from "@mui/material/Rating";

const SR = styled(Rating)({
    '& .MuiRating-iconFilled': {
        // color: '#006856',
        color: '#FFB300',
    },
    '& .MuiRating-iconHover': {
        color: '#FFB300',
    },
    '& .MuiRating-icon': {
        color: '#FFB300',
    },
});

const StyledRating = ({ratingAVG}) => {
    return (
        <SR name={`half-rating-read`}
            value={ratingAVG}
            precision={0.5}
            readOnly
        />
    );
}

export default StyledRating;

